export enum LabelSizes {
  "x6" = "x6",
  "x8" = "x8",
}
